import { Action } from "../../../actions/actions";
import { PresetsActionTypes } from "../actions/actionTypes";

export interface Denominations {
    country_id: number;
    denominations: number[];
}

export function denominations(state: Denominations[] = [], action: Action) {
    switch (action.type) {
        case PresetsActionTypes.GET_DENOMINATIONS_SUCCESS:
            return action.payload.results;
        default:
            return state;
    }
}

export function denominationsLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case PresetsActionTypes.GET_DENOMINATIONS:
            return true;
        case PresetsActionTypes.GET_DENOMINATIONS_SUCCESS:
        case PresetsActionTypes.GET_DENOMINATIONS_FAIL:
            return false;
        default:
            return state;
    }
}
